module.exports = "<svg id=\"fec4500f-1bfc-48c0-a945-4ed925835d54\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.69 47.73\"><title>fb</title><path d=\"M16.12,47.73V26h2.51c1.38,0,2.76,0,4.14,0a.83.83,0,0,0,.62-.45c.37-2.65.7-5.3,1.06-8H16.21c0-2.35-.12-4.61.05-6.85C16.38,9,17.34,8.27,19,8.1,20.26,8,21.57,8,22.86,8h1.83V.36c-.4,0-.81-.12-1.22-.14-3-.15-6.13-.56-9.14.36a9.51,9.51,0,0,0-6.9,8.55c-.16,2.43-.11,4.88-.16,7.32,0,.31,0,.62,0,1H0V26H7.21V47.68c-.18,0-.38,0-.57,0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fb.svg
// module id = 562
// module chunks = 1